import { render, staticRenderFns } from "./TextFollowup.vue?vue&type=template&id=f342ef08&"
import script from "./TextFollowup.vue?vue&type=script&lang=js&"
export * from "./TextFollowup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports